interface UrlEntry {
  id: string
  link: string
  platform: string
}

interface SpecificPostUrlEntry {
  id: string
  link: string
  platform: string
}

export interface AnalysisDraft {
  captionSearch: {
    keyword: string
    urls: UrlEntry[]
  } | null
  category?: string
  recentPosts: {
    postCount: number
    urls: UrlEntry[]
  } | null
  specificPosts: {
    urls: SpecificPostUrlEntry[]
  } | null
  title: string
}

const CONTENT_ANALYSIS_DRAFT_KEY = 'content_analysis_draft'

export const saveContentAnalysisDraft = (draft: AnalysisDraft): void => {
  try {
    localStorage.setItem(CONTENT_ANALYSIS_DRAFT_KEY, JSON.stringify(draft))
  } catch (error) {
    console.error('Failed to save content analysis draft:', error)
  }
}

export const getContentAnalysisDraft = (): AnalysisDraft | null => {
  try {
    const saved = localStorage.getItem(CONTENT_ANALYSIS_DRAFT_KEY)
    if (!saved) return null
    const parsed = JSON.parse(saved)
    // Ensure title field exists for backwards compatibility
    return {
      ...parsed,
      title: parsed.title || '',
    }
  } catch (error) {
    console.error('Failed to get content analysis draft:', error)
    return null
  }
}

export const clearContentAnalysisDraft = (): void => {
  try {
    localStorage.removeItem(CONTENT_ANALYSIS_DRAFT_KEY)
  } catch (error) {
    console.error('Failed to clear content analysis draft:', error)
  }
}
